import React from 'react';

import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { closeOtherDetailsPanel, openCreateOKRPanel } from 'components/RabbitOKRSidePanel/krDrawerSecondaryPanelSlice';
import { useDispatch } from 'react-redux';

import { sendGoalEditedClickedEvent } from 'constants/mixpanelHelper';
import { GOALS_EVENT_SOURCES } from 'constants/trackingEvents';

import { Button } from 'uiToolkitV1/Button';

export const onOtherDetailsPanelCancel = (dispatch, history, originalDetails, okrDetails, isOpenAsChild) => {
  // @ts-ignore
  dispatch(closeOtherDetailsPanel());
  dispatch(updateOKR(originalDetails));
  if (isOpenAsChild) {
    dispatch(
      openCreateOKRPanel({
        okrDetails: { ...okrDetails },
        isSkipResetState: true,
      })
    );
  }
};

const OtherDetailsFooter = ({ secondaryPanelDetails, isErrorInForm, handleBackAndCancelButtonClick }) => {
  const dispatch = useDispatch();

  return (
    <>
      <Button
        variant="tertiary"
        mr="auto"
        onClick={() => {
          handleBackAndCancelButtonClick();
        }}
      >
        Cancel
      </Button>
      <Button
        isDisabled={isErrorInForm}
        onClick={() => {
          sendGoalEditedClickedEvent({
            eventProperties: {
              source: 'Save Details Button',
              goalId: secondaryPanelDetails?.okrDetails?.uuid || 'NA',
              type: GOALS_EVENT_SOURCES.ADD_GOAL_PANEL,
            },
          });
          if (secondaryPanelDetails?.isOpenAsChild) {
            dispatch(
              openCreateOKRPanel({
                okrDetails: { ...secondaryPanelDetails?.okrDetails },
                isSkipResetState: true,
              })
            );

            return;
          }
          if (!secondaryPanelDetails?.isOpenAsChild) {
            // @ts-ignore
            dispatch(closeOtherDetailsPanel());
          }
        }}
      >
        Save
      </Button>
    </>
  );
};

export { OtherDetailsFooter };
